export default __webpack_public_path__ + "static/media/major-purchase.65432157.svg";